export const ErrorConstants = {
    errorMessage: "No Data Available",
    errorHtml: "<div class='no-data'><p>No Data Available</p></div>"
};